import { render, staticRenderFns } from "./ATNOFSPub.vue?vue&type=template&id=268d9578&scoped=true&"
import script from "./ATNOFSPub.vue?vue&type=script&lang=js&"
export * from "./ATNOFSPub.vue?vue&type=script&lang=js&"
import style0 from "./ATNOFSPub.vue?vue&type=style&index=0&id=268d9578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268d9578",
  null
  
)

export default component.exports